/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AdhesionDataEntreprisesItem } from "@src/adhesion/AdhesionData/adhesionDataEntreprises";
import { ImportSocietesError } from "@src/adhesion/Steps/AdhesionModeImport/useImportSocietes";
import { AssujettiDataItemError } from "@src/assujettis/AssujettiData";
import { assujettiExcelTemplate } from "@src/assujettis/ImportExport/AssujettiExcelTemplate";
import { entrepriseExcelTemplate } from "@src/societes/export/EntrepriseExcelTemplate";
import axios from "axios";
import { Row, Workbook, Worksheet } from "exceljs";
import { get } from "lodash";
import {
  ExcelPropertyType,
  ExcelTemplate,
  ExportCellTemplate,
} from "./excel.definition";

const NUMBER_OF_LINE_TO_VALIDATE = 2000;

export async function downloadSheetFromWorkbook(
  fileName: string,
  workbook: Workbook
) {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}

export async function importWorkBookFromFile(
  filePath: string
): Promise<Workbook> {
  const workbook = new Workbook();
  const response = await axios.get(`/${filePath}`, {
    responseType: "arraybuffer",
  });
  return workbook.xlsx.load(response.data as ArrayBuffer);
}

export function insertDataInSheet<TTemplate extends ExcelTemplate>(
  rows: unknown[],
  sheet: Worksheet,
  template: TTemplate,
  exportTemplate: ExportCellTemplate[]
) {
  sheet.duplicateRow(template.firstRowIndex + 1, rows.length, true);
  rows.forEach((row, index) => {
    sheet.getRow(index + template.firstRowIndex + 1).values =
      exportTemplate.map((cellTemplate) => {
        if (!cellTemplate) return null;
        const rawValue = get(row, cellTemplate.path) as
          string | boolean | number | Date | null | undefined;
        if (rawValue === null || rawValue === undefined) return null;
        switch (cellTemplate.type) {
          case ExcelPropertyType.boolean:
            return rawValue ? "OUI" : "NON";
          case ExcelPropertyType.date:
            return rawValue;
          case ExcelPropertyType.number:
            return rawValue;
          case ExcelPropertyType.string:
          default:
            return rawValue;
        }
      });
  });
}
const formulaeOuiNon = "=Données!$C$2:$C$200";
const formulaeSocieteByColumn: Record<string, string> = {
  C: "=Données!$A$2:$A$200",
  E: "=Données!$O$2:$O$200",
  K: "=Données!$M$2:$M$200",
  L: "=Données!$E$2:$E$200",
  N: formulaeOuiNon,
  O: formulaeOuiNon,
  P: formulaeOuiNon,
  Q: formulaeOuiNon,
  R: formulaeOuiNon,
  S: formulaeOuiNon,
  T: formulaeOuiNon,
  U: formulaeOuiNon,
  V: "=Données!$G$2:$G$200",
  W: "=Données!$G$2:$G$200",
  X: "=Données!$G$2:$G$200",
  Y: "=Données!$G$2:$G$200",
  Z: "=Données!$G$2:$G$200",
  AA: "=Données!$G$2:$G$200",
  AB: "=Données!$G$2:$G$200",
  AC: "=Données!$G$2:$G$200",
  AD: "=Données!$G$2:$G$200",
  AE: "=Données!$G$2:$G$200",
  AF: "=Données!$G$2:$G$200",
  AG: "=Données!$G$2:$G$200",
  AH: "=Données!$I$2:$I$200",
  AI: "=Données!$I$2:$I$200",
  AJ: "=Données!$I$2:$I$200",
  AK: "=Données!$K$2:$K$200",
  AL: formulaeOuiNon,
  AM: "=Données!$Q$2:$Q$200",
};
const formulaeAssujettiByColumn: Record<string, string> = {
  D: "=Données!$A$2:$A$200",
  G: formulaeOuiNon,
  H: formulaeOuiNon,
  O: formulaeOuiNon,
  P: "=Données!$E$2:$E$200",
  Q: "=Données!$I$2:$I$200",
  R: "=Données!$K$2:$K$200",
  T: "=Données!$O$2:$O$200",
  U: "=Données!$S$2:$S$200",
  V: formulaeOuiNon,
  AH: formulaeOuiNon,
  AI: "=Données!$G$2:$G$200",
  AJ: "=Données!$I$2:$I$200",
  AK: "=Données!$M$2:$M$200",
  AM: "=Données!$Q$2:$Q$200",
  AN: "=Données!$U$2:$U$200",
  AO: formulaeOuiNon,
  AP: formulaeOuiNon,
  AQ: formulaeOuiNon,
  AR: formulaeOuiNon,
  AS: formulaeOuiNon,
};
const formulaeRegistreFormationiByColumn: Record<string, string> = {
  E: "='Listes déroulantes'!$F$2:$F$4",
  I: "='Listes déroulantes'!$D$2:$D$4",
  J: "='Listes déroulantes'!$A$2:$A$8",
  K: "='Listes déroulantes'!$K$2:$K$10",
};
function setDataValidationList(row: Row, column: string, formulae: string) {
  row.getCell(column).dataValidation = {
    type: "list",
    allowBlank: true,
    formulae: [formulae],
  };
}

export const TEMPLATE_SOCIETES_FIRST_ROW = 3;
export function addSocieteDataValidationToSheet(
  worksheet: Worksheet,
  numberOfEditedLines: number
) {
  worksheet.insertRows(
    numberOfEditedLines + TEMPLATE_SOCIETES_FIRST_ROW,
    new Array(NUMBER_OF_LINE_TO_VALIDATE + numberOfEditedLines)
      .fill(null)
      .map(() => [undefined, undefined, undefined, ""])
  );
  worksheet.eachRow((row, index) => {
    if (index < TEMPLATE_SOCIETES_FIRST_ROW) return;
    Object.entries(formulaeSocieteByColumn).forEach(([column, formulae]) => {
      setDataValidationList(row, column, formulae);
    });
  });
}
export const TEMPLATE_ASSUJETTIS_FIRST_ROW = 4;
export function addAssujettiDataValidationToSheet(
  worksheet: Worksheet,
  numberOfEditedLines: number
) {
  worksheet.insertRows(
    numberOfEditedLines + TEMPLATE_ASSUJETTIS_FIRST_ROW,
    new Array(NUMBER_OF_LINE_TO_VALIDATE + numberOfEditedLines)
      .fill(null)
      .map(() => [undefined, undefined, undefined, ""])
  );
  worksheet.eachRow((row, index) => {
    if (index < TEMPLATE_ASSUJETTIS_FIRST_ROW) return;
    Object.entries(formulaeAssujettiByColumn).forEach(([column, formulae]) => {
      setDataValidationList(row, column, formulae);
    });
  });
}

export const TEMPLATE_REGISTRE_FORMATION_FIRST_ROW = 3;
export function addRegistreFormationDataValidationToSheet(
  worksheet: Worksheet,
  numberOfEditedLines: number
) {
  worksheet.insertRows(
    numberOfEditedLines + TEMPLATE_REGISTRE_FORMATION_FIRST_ROW,
    new Array(NUMBER_OF_LINE_TO_VALIDATE + numberOfEditedLines)
      .fill(null)
      .map(() => [undefined, undefined, undefined, ""])
  );
  worksheet.eachRow((row, index) => {
    if (index < TEMPLATE_REGISTRE_FORMATION_FIRST_ROW) return;
    Object.entries(formulaeRegistreFormationiByColumn).forEach(
      ([column, formulae]) => {
        setDataValidationList(row, column, formulae);
      }
    );
  });
}

function excelColToIndex(col: string): number {
  const upperCol = col.toUpperCase();
  let colNumber = 0;
  const len = col.length;
  for (let i = 0; i < len; i += 1) {
    colNumber += 26 ** (len - i - 1) * (upperCol.charCodeAt(i) - 64);
  }
  return colNumber - 1;
}

export function getExportTemplateFromTemplate(
  template: ExcelTemplate
): ExportCellTemplate[] {
  let maxColIndex = 0;

  const recordOfExportCellTemplate = Object.entries(template.categories).reduce<
    Record<number, ExportCellTemplate>
  >((acc, [categoryName, category]) => {
    const categoryColumns = Object.entries(category.columns);
    categoryColumns.forEach(([columnName, column]) => {
      const colIndex = excelColToIndex(column.col);
      maxColIndex = Math.max(maxColIndex, colIndex);
      acc[colIndex] = {
        path: `${categoryName}.${columnName}`,
        type: column.type,
      };
    });
    return acc;
  }, {});
  return Array.from({ length: maxColIndex + 1 }).map(
    (_, index) => recordOfExportCellTemplate[index] || null
  );
}

export function colorErrorsSocietesInSheet(
  sheet: Worksheet,
  entreprises: ImportSocietesError[]
) {
  sheet.eachRow((row, rowIndex) => {
    if (rowIndex < TEMPLATE_SOCIETES_FIRST_ROW) return;

    const entrepriseIndex = rowIndex - TEMPLATE_SOCIETES_FIRST_ROW;
    const entreprise = entreprises[entrepriseIndex];
    if (!entreprise.errors || entreprise.errors.length === 0) return;
    const rowErrorsKeys = entreprise.errors.map(({ key }) => key);
    const columns = rowErrorsKeys.flatMap((e) => {
      const endWithNumber = [
        "organisationPro",
        "sousCategorieCobsp",
        "sousCategorieMiobsp",
      ];
      const columnKey = endWithNumber.includes(e) ? `${e}1` : e;
      const categoriesOriasKey: keyof AdhesionDataEntreprisesItem =
        "categoriesOrias";
      const categoriesOriasColumnsKeys = [
        "categorieOriasCOA",
        "categorieOriasMIA",
        "categorieOriasCOBSP",
        "categorieOriasMIOBSP",
      ];
      if (e === categoriesOriasKey)
        return categoriesOriasColumnsKeys.map(
          (k) => entrepriseExcelTemplate.categories.main.columns[k]?.col
        );
      return entrepriseExcelTemplate.categories.main.columns[columnKey]?.col;
    });

    if (!columns || columns.length === 0) return;
    columns.forEach((col) => {
      row.getCell(col).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF0000" },
      };
    });
  });
}

type CategoriesAssujetti = typeof assujettiExcelTemplate.categories;

const colonnesFormationContinue = (
  prefixe: string,
  colonnes:
    | CategoriesAssujetti["formationContinueIAS"]["columns"]
    | CategoriesAssujetti["formationContinueIOBSP"]["columns"]
) => ({
  [`${prefixe}.soumisFormation`]: colonnes.soumisFormation.col,
  [`${prefixe}.dateDernierVerification`]: colonnes.dateSaisie.col,
  [`${prefixe}.formations.0.theme`]: colonnes.formation0Theme.col,
  [`${prefixe}.formations.0.nombreHeures`]: colonnes.formation0Heures.col,
  [`${prefixe}.formations.1.theme`]: colonnes.formation1Theme.col,
  [`${prefixe}.formations.1.nombreHeures`]: colonnes.formation1Heures.col,
});

const colonnesCapacitePro = (
  prefixe: string,
  colonnes:
    | CategoriesAssujetti["capaciteProIAS"]["columns"]
    | CategoriesAssujetti["capaciteProIOBSP"]["columns"]
) => ({
  [`${prefixe}.datePriseFonction`]: colonnes.datePriseFonction.col,
  [`${prefixe}.conditionCapaciteProfessionnelle`]:
    colonnes.soumisALaCondition.col,
  [`${prefixe}.niveau`]: colonnes.niveau.col,
  [`${prefixe}.statusProfessionel`]: colonnes.statutPro.col,
  [`${prefixe}.categorie`]: colonnes.categorie.col,
  [`${prefixe}.nomDiplome`]: colonnes.nomDiplome.col,
  [`${prefixe}.gradeDiplome`]: colonnes.gradeDiplome.col,
  [`${prefixe}.typeJustificatif`]: colonnes.justificatif.col,
});

const colonneParCheminErreurAssujetti = (): Record<string, string> => {
  const {
    assujetti,
    honorabilite,
    formationContinueIAS,
    capaciteProIAS,
    formationContinueIOBSP,
    capaciteProIOBSP,
    axesOptionnels,
  } = assujettiExcelTemplate.categories;
  return {
    "assujetti.sirenCompany": assujetti.columns.sirenCompany.col,
    "assujetti.name": assujetti.columns.name.col,
    "assujetti.surname": assujetti.columns.surname.col,
    "assujetti.role": assujetti.columns.role.col,
    "assujetti.email": assujetti.columns.mail.col,
    "assujetti.optionalAxes": axesOptionnels.columns.honorabilite.col,
    "assujetti.optionalAxesDescription": axesOptionnels.columns.description.col,
    "honorabilite.lastVerifiedAt": honorabilite.columns.dateVerif.col,
    "honorabilite.isHonourable": honorabilite.columns.honorable.col,
    ...colonnesFormationContinue(
      "formationContinueIAS",
      formationContinueIAS.columns
    ),
    ...colonnesFormationContinue(
      "formationContinueIOBSP",
      formationContinueIOBSP.columns
    ),
    "formationContinueIOBSP.heuresFormationCreditConsommation":
      formationContinueIOBSP.columns.heuresFormationCreditConsommation.col,
    "formationContinueIOBSP.heuresFormationCreditImmobilier":
      formationContinueIOBSP.columns.heuresFormationCreditImmobilier.col,
    "formationContinueIOBSP.heuresFormationCreditPretViagerHypotecaire":
      formationContinueIOBSP.columns.heuresFormationCreditPretViagerHypotecaire
        .col,
    "formationContinueIOBSP.heuresFormationCreditRegroupementCredits":
      formationContinueIOBSP.columns.heuresFormationCreditRegroupementCredits
        .col,
    "formationContinueIOBSP.heuresFormationCreditServicePaiement":
      formationContinueIOBSP.columns.heuresFormationCreditServicePaiement.col,
    ...colonnesCapacitePro("capaciteProIAS", capaciteProIAS.columns),
    ...colonnesCapacitePro("capaciteProIOBSP", capaciteProIOBSP.columns),
  };
};

const getErrorColumn = (cheminErreur: string): string | undefined => {
  const colonneParChemin = colonneParCheminErreurAssujetti();
  const segments = cheminErreur.split(".");
  return segments
    .map((_, longueur) =>
      segments.slice(0, segments.length - longueur).join(".")
    )
    .map((chemin) => colonneParChemin[chemin])
    .find((colonne) => colonne !== undefined);
};

export function colorErrorsAssujettisInSheet(
  sheet: Worksheet,
  assujettis: AssujettiDataItemError[]
) {
  sheet.eachRow((row, rowIndex) => {
    if (rowIndex < TEMPLATE_ASSUJETTIS_FIRST_ROW) return;

    const assujettiEnErreur =
      assujettis[rowIndex - TEMPLATE_ASSUJETTIS_FIRST_ROW];
    if (!assujettiEnErreur?.errors?.length) return;

    assujettiEnErreur.errors
      .map(({ key }) => getErrorColumn(key))
      .filter((colonne): colonne is string => colonne !== undefined)
      .forEach((colonne) => {
        row.getCell(colonne).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF0000" },
        };
      });
  });
}
